module.exports = __webpack_public_path__ + "static/UnjustThumbnail-aa512e84a70b4752439bfe5090cd7c4c.png";